export default "__VITE_ASSET__DWhzV79d__"